<nz-modal [(nzVisible)]="isVisibleDepositModal" nzClassName="siteModal site-edit-modal invoice-modal"
    [nzTitle]="titleTemplate" (nzOnCancel)="handleCancel(null)" [nzFooter]="footerTpl" nzCentered
    [nzMaskClosable]="false">
    <ng-template #titleTemplate let-control>
        {{depositCheckNum}}
        <span nz-icon nzType="sync" nzTheme="outline" [nzSpin]="isResyncingData" (click)="resynDepositData()"
            class="ml-1 x-lg" nz-tooltip [nzTooltipTitle]="isResyncingData ? 'Syncing...' : 'Resync Deposit'"></span>
    </ng-template>
    <ng-container *nzModalContent class="h-100">
        <div style="overflow: auto; height: 75vh" cdkScrollable>
            <div class="page-padding bg-white-color">
                <div nz-row class="d-flex align-i-c ">
                    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                        <h1 class="page-title-text tab-title">Deposit Details</h1>
                    </div>
                </div>
            </div>
            <div class="page-padding bg-white-color">
                <div class="detail-box customer-detail-box" nz-row>
                    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="quickbooks-bg-color">
                        <div nz-row class="quickbooks-bg-color quickboos-box" style=" border-bottom: 0;">
                            <div class="box-padding">
                                <nz-skeleton *ngIf="this.isDepositSkeleton" [nzParagraph]="{ rows: 15,width: 10}"
                                    [nzActive]="true"></nz-skeleton>
                                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                                    class="section-top-padding" *ngIf="!this.isDepositSkeleton">
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">User</label>
                                        <p class="investment-company-name pb-0">
                                            QBO
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Submitted</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.createdOn != null && this.getDepositDetail?.createdOn != '') else elsepart ">{{this.getDepositDetail?.createdOn.slice(0,-1)
                                                | date: 'MM/dd/yyyy'}} |
                                                {{getDepositDetail.createdOn.toString().slice(0,-1)
                                                | date:'shortTime' }}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Type</label>
                                        <p class="investment-company-name pb-0">
                                            Deposit
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Memo</label>
                                        <p class="investment-company-name pb-0">
                                            <span class="multiline-text"
                                                *ngIf="(this.getDepositDetail?.memo != null && this.getDepositDetail?.memo != '') else elsepart ">{{this.getDepositDetail?.memo}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Ref No.</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.depositCheckNum != null && this.getDepositDetail?.depositCheckNum != '') else elsepart ">
                                                <a target="_blank"
                                                    [href]="qboURL + '/app/deposit?txnId='+this.getDepositDetail?.qboEntityId">{{this.getDepositDetail?.depositCheckNum}}</a>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Deposit Date</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.depositDate != null && this.getDepositDetail?.depositDate != '') else elsepart ">{{this.getDepositDetail?.depositDate.toString().slice(0,-1)
                                                | date: 'MM/dd/yyyy'}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="d-flex mb-1">
                                        <label class="investment-approve-label-text">Account</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.depositAccount != null && this.getDepositDetail?.depositAccount != '') else elsepart ">{{this.getDepositDetail?.depositAccount}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex mb-1">
                                        <label class="investment-approve-label-text">Company</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.repName != null && this.getDepositDetail?.repName != '') else elsepart ">{{this.getDepositDetail?.repName}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex mb-1">
                                        <label class="investment-approve-label-text">Class</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.class.name != null && this.getDepositDetail?.class.name != '') else elsepart ">{{this.getDepositDetail?.class.name}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex mb-1">
                                        <label class="investment-approve-label-text">Description</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.description != null && this.getDepositDetail?.description != '') else elsepart ">{{this.getDepositDetail?.description}}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Amount</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.amount != null && this.getDepositDetail?.amount != '') else elsepart ">{{this.getDepositDetail?.amount
                                                | currency }}</span>
                                        </p>
                                    </div>
                                    <div class="d-flex align-i-c mb-1">
                                        <label class="investment-approve-label-text">Net</label>
                                        <p class="investment-company-name pb-0">
                                            <span
                                                *ngIf="(this.getDepositDetail?.amount != null && this.getDepositDetail?.amount != '') else elsepart ">{{this.getDepositDetail?.amount
                                                > 0 ? '+' : ''}}{{this.getDepositDetail?.amount
                                                | currency }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #elsepart let-event>
                        <span>-</span>
                    </ng-template>
                    <form nz-form [formGroup]="_fS.expenseForm" class="estimate-box">
                        <div nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                                <nz-form-item>
                                    <nz-form-control [nzErrorTip]="programError">
                                        <label class="label-text required border-bottom">Select program period</label>
                                        <nz-select nzShowSearch nzPlaceHolder="Select Program Period"
                                            [nzSize]="'default'" formControlName="programPeriod" [nzSelectOnTab]="true">
                                            <ng-container *ngFor="let option of listOfProgramPeriods">
                                                <nz-option *ngIf="!isLoadingPrograms" [nzLabel]="option.label"
                                                    [nzValue]="option.id">
                                                </nz-option>
                                            </ng-container>
                                            <nz-option *ngIf="isLoadingPrograms" nzCustomContent>
                                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                                Loading Data...
                                            </nz-option>
                                        </nz-select>
                                        <ng-template #programError let-control>
                                            <ng-container *ngIf="control.hasError('required')">Please select program
                                                period
                                            </ng-container>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                                <nz-form-item>
                                    <nz-form-control [nzErrorTip]="tagError">
                                        <div class="d-flex align-i-c justify-content-space-between"><label
                                                class="label-text required">
                                                Tags</label></div>
                                        <nz-select nzShowSearch nzPlaceHolder="Select Tag" [nzSize]="'default'"
                                            formControlName="tags" (nzFocus)="getTags()" [nzSelectOnTab]="true"
                                            (ngModelChange)="checkTagGroupData($event)" [nzServerSearch]="true"
                                            [nzCustomTemplate]="defaultTemplate"
                                            (nzOnSearch)="returnFilteredTags($event)">
                                            <ng-container *ngFor="let option of listOfTags">
                                                <ng-container *ngIf="!isLoadingTags">
                                                    <nz-option-group [nzLabel]="optionGrouptemplate">
                                                        <nz-option *ngFor="let tag of option.Tags" nzCustomContent
                                                            [nzValue]="tag._id" [nzLabel]="tag.Name">
                                                            <span class="tag-list ml-2">
                                                                <span [ngStyle]="{'background-color': option.Color }"
                                                                    style="width: 10px;height:30px"></span>&nbsp;{{option.Name}}{{option.Name
                                                                != 'Uncategorized' ? ':' : ''}}&nbsp;
                                                                <b *ngIf="option.Name != 'Uncategorized'">{{
                                                                    tag.Name }}</b>
                                                            </span>
                                                        </nz-option>
                                                    </nz-option-group>
                                                    <ng-template #optionGrouptemplate><span
                                                            class="d-flex align-i-c"><span
                                                                class="rountTagGroupColor rount-tag"
                                                                [ngStyle]="{'background-color':option.Color}"></span><span
                                                                class="tag-group pl-15">{{option.Name}}</span></span></ng-template>
                                                </ng-container>
                                            </ng-container>
                                            <nz-option *ngIf="isLoadingTags" nzDisabled nzCustomContent>
                                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                                Loading Data...
                                            </nz-option>
                                        </nz-select>
                                        <ng-template #defaultTemplate let-selected>
                                            <span class="tag-list ml-2">
                                                <span [ngStyle]="{'background-color': this.selectedTagGroup?.Color }"
                                                    style="width: 10px;height:30px"></span>&nbsp;{{
                                                selectedTagGroup?.Name
                                                }}{{selectedTagGroup.Name != 'Uncategorized' ? ':' : ''}}&nbsp; <b
                                                    *ngIf="selectedTagGroup.Name != 'Uncategorized'">{{
                                                    selected?.nzLabel }}</b>
                                            </span>

                                        </ng-template>
                                        <ng-template #tagError let-control>
                                            <ng-container *ngIf="control.hasError('required')">Please select
                                                tag</ng-container>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="6" nzXl="4">
                                <nz-form-item class="margin-none h-100">
                                    <nz-form-control class="switch-box justify-content-center">
                                        <nz-switch formControlName="isNonAlc"></nz-switch>
                                        <label class="switch-label black mr-1">Non-Alc</label>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-space-between footer-box">
            <div class="ant-drawer-footer invoice-footer justify-content-space-between">
                <div class="">
                </div>
                <div class="d-flex">
                    <button nz-button nzType="default" (click)="handleCancel(null)"
                        class="dlt-btn width-100">Close</button>
                    <button nz-button nzType="primary" class="medium-btn width-100" [nzLoading]="isLoadingDeposit"
                        (click)="updateDeposit()">Update</button>
                </div>
            </div>
        </div>
    </ng-template>
</nz-modal>